import { render, staticRenderFns } from "./species-view.vue?vue&type=template&id=61aad813&scoped=true&"
import script from "./species-view.vue?vue&type=script&lang=js&"
export * from "./species-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aad813",
  null
  
)

export default component.exports